import React from "react"
import DatatableComponent from "../../../../../../components/common/DatatableComponent/DatatableComponent"

const CompetitivenessStatusBreakdown = () => {

  const data = [
    { name: 'Product 1', yourPrice: '$50.00', competitorPrice: '$45.00', status: 'Not Competitive' },
    { name: 'Product 1', yourPrice: '$50.00', competitorPrice: '$45.00', status: 'Not Competitive' },
    { name: 'Product 1', yourPrice: '$50.00', competitorPrice: '$45.00', status: 'Not Competitive' },
    { name: 'Product 1', yourPrice: '$50.00', competitorPrice: '$45.00', status: 'Not Competitive' },
    { name: 'Product 1', yourPrice: '$50.00', competitorPrice: '$45.00', status: 'Not Competitive' },
    { name: 'Product 1', yourPrice: '$50.00', competitorPrice: '$45.00', status: 'Not Competitive' },
    { name: 'Product 1', yourPrice: '$50.00', competitorPrice: '$45.00', status: 'Not Competitive' },
    { name: 'Product 1', yourPrice: '$50.00', competitorPrice: '$45.00', status: 'Not Competitive' },
    { name: 'Product 1', yourPrice: '$50.00', competitorPrice: '$45.00', status: 'Not Competitive' },
    { name: 'Product 1', yourPrice: '$50.00', competitorPrice: '$45.00', status: 'Not Competitive' },
  ]

  const columns = [
    { name: 'Product Name', selector: row => row.name },
    { name: 'Your Price', selector: row => row.yourPrice },
    { name: 'Competitor Price', selector: row => row.competitorPrice },
    { name: 'Competitiveness Status', selector: row => row.status },
    { name: 'Action', cell: () => <span className="cursor-pointer">View Product</span> }
  ]

  return (
    <section>
      <div className="fw-semibold fs-5 my-3">Competitiveness Status Breakdown</div>

      <div className="p-1 bg-white">
        <div className="border border-subtle-secondary p-3">
          <div>Detailed information about each product's competitiveness.</div>

          <DatatableComponent columns={columns} data={data} pagination type="gray" />
        </div>
      </div>

    </section>
  )
}

export default CompetitivenessStatusBreakdown
